import { useQueryClient } from '@tanstack/react-query';
import { Segmented } from 'antd';
import { useTranslation } from 'react-i18next';

import { getAuthMeQueryKey, useAuthUpdateMe } from '@/api/generated/endpoints/auth/auth';
import type { MeOut } from '@/api/generated/model';
import { changeLanguage, currentLanguage, isLanguage, LANGUAGES, type Language } from '@/i18n';

/**
 * RU / AZ. Без входа — язык этого браузера; после входа — ещё и в профиль (ADR-0008),
 * чтобы язык следовал за человеком на любом компьютере.
 */
export function LanguageSwitch({
  saveToProfile,
  onChanged,
}: {
  saveToProfile: boolean;
  onChanged?: (language: Language) => void;
}) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const update = useAuthUpdateMe({
    mutation: {
      onSuccess: (me) => {
        queryClient.setQueryData<MeOut>(getAuthMeQueryKey(), me);
      },
    },
  });

  return (
    <Segmented<Language>
      size="small"
      aria-label={t('common.language')}
      value={currentLanguage()}
      options={LANGUAGES.map((l) => ({ value: l, label: l.toUpperCase() }))}
      onChange={(l) => {
        if (!isLanguage(l)) return;
        void changeLanguage(l);
        if (saveToProfile) update.mutate({ data: { locale: l } });
        onChanged?.(l);
      }}
    />
  );
}
